import { cacheActions } from '@redux/slices/cache';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';
import { initWebWorker } from 'webworker';
import _ from 'lodash';
import moment from 'moment';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';

const equipmentJsonManipulationJson = async ({ initialLogin, data, isSettingUpdated }) => {
  const { items } = data;
  const { cache } = store.getState();
  const { equipmentsMap = {}, equipments = [], pendingSync } = cache;

  const isCheckOldAndNewArray =
    !initialLogin && items?.length && equipments?.length && !isSettingUpdated;

  let newList = [];
  newList = !isCheckOldAndNewArray
    ? items?.map((task) => {
        const found = equipments.findIndex((t) => t.equipmentId === task.equipmentId) + 1;

        if (found && equipments[found - 1].equipmentEditingStatus) {
          return { ...equipments[found - 1] };
        } else {
          return task;
        }
      })
    : items;

  const newEquipmentsList = equipments?.filter((x) => x?.isNew) || [];

  newList = [...newList, ...newEquipmentsList];

  if (pendingSync == 0) {
    newList = newList?.filter((x) => !x?.isNew && !x?.notSHhowOnList);
  }

  const dataNew = await initWebWorker({
    args: {
      equipmentPayloadData: !isCheckOldAndNewArray ? newList || [] : [],
      isCheckOldAndNewArray: isCheckOldAndNewArray
        ? {
            oldArray: equipments,
            oldArrayMap: equipmentsMap,
            newArray: items,
            idName: 'equipmentId',
            compareThemStatus: true,
            compareThemStatusField: 'equipmentEditingStatus'
          }
        : false
    },
    type: 'equipment-mobile-data-redux',
    timeout: 1000000
  });
  return dataNew?.result;
};

const equipmentDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(cacheActions.setEquipments(data));
};

const newAndEditedSyncedEquipmentManipulationJson = async ({
  initialLogin,
  data,
  isSettingUpdated
}) => {
  const items = data || [];
  const { cache } = store.getState();
  const { syncedNewAndEditedEquipments = [] } = cache;

  let newList = [];

  const allNewAndEditedEquipmentMap =
    _.size(syncedNewAndEditedEquipments) > 0 && !initialLogin
      ? syncedNewAndEditedEquipments?.reduce((acc, equipment) => {
          acc[equipment.id] = true;
          return acc;
        }, {})
      : {};

  if (!initialLogin && items?.length && syncedNewAndEditedEquipments?.length && !isSettingUpdated) {
    const combineNewAndOldArray = checkOldAndNewArray({
      oldArray: syncedNewAndEditedEquipments,
      oldArrayMap: allNewAndEditedEquipmentMap,
      newArray: items,
      idName: 'id'
    });

    newList = combineNewAndOldArray;
  } else {
    if (items?.length > 0) newList = items;
  }

  const syncedEquipmentAll = newList?.map((equipment) => ({
    ...equipment,
    equipmentEditingStatus: 'Synced',
    type: 'New or edited asset'
  }));

  let newSyncedEquipments = [];
  if (!_.isEmpty(allNewAndEditedEquipmentMap)) {
    newSyncedEquipments = syncedEquipmentAll.map((equ) => {
      if (!allNewAndEditedEquipmentMap[equ.id]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...equ
        };
      } else return equ;
    });
  } else newSyncedEquipments = syncedEquipmentAll;

  newSyncedEquipments = [...(newSyncedEquipments || [])];

  return newSyncedEquipments;
};

const newAndEditedSyncedEquipmentDispatcher = async ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(cacheActions.setSyncedEquipments(data));
};

export {
  equipmentJsonManipulationJson,
  equipmentDispatcher,
  newAndEditedSyncedEquipmentManipulationJson,
  newAndEditedSyncedEquipmentDispatcher
};
